import CollaborationStore from '@/store/collaboration.store';
import SrcContent from './SrcContent';
import CollaborationSidebar from '@/pages/Collaboration/CollaborationSidebar';
import Dialog from '@/component/Dialog';
import { RuningInLink } from '@/constants';
import SyncSuccessIcon from '@/assets/summary/sync_success.svg?react';
import TranslationSelector from '@/components/TranslationSelector';
import './index.less';
import { useCollaborationSocket } from '@/hooks/useCollaborationSocket';
import useLoginStore from '@/store/login.store';
import LogoHeader from '@/sections/LogoHeader';
import TitleHeader from '@/sections/TitleHeader';
import { useEffect } from 'react';

const WebCollaboration = () => {
  const showbar = CollaborationStore((state) => state.showSidebar);
  const meetingFinish = CollaborationStore((state) => state.meetingFinish);
  const showExitDialog = CollaborationStore((state) => state.showExitDialog);
  const setShowExitDialog = CollaborationStore((state) => state.setShowExitDialog);
  const translationOption = CollaborationStore((state) => state.translationOption);
  const setTranslationOption = CollaborationStore((state) => state.setTranslationOption);
  const isVisitor = useLoginStore((state) => state.isVisitor);

  const {
    streamId,
    showJumpSummaryDialog,
    setShowJumpSummaryDialog,
    setModalCancel,
    handleJumpSummary,
    navigate,
  } = useCollaborationSocket();

  // 访客模式下的跳转处理
  useEffect(() => {
    if (isVisitor && showJumpSummaryDialog) {
      navigate('/meetingEnd', { replace: true });
    }
  }, [isVisitor, showJumpSummaryDialog, navigate]);

  const handleExit = () => {
    navigate('/home');
  };

  return (
    <div className="overflow-hidden bg-transparent h-full flex-shrink-0 flex flex-col  bg-no-repeat bg-#F2F3F5/88 shadow bg-contain">
      {!RuningInLink && (
        <div className="w-full flex flex-row items-center justify-between pl-8">
          {isVisitor && <LogoHeader />}
          {!isVisitor && <TitleHeader title="" popupType='dialog' buttonOrder='reverse' backPop={{
            popTitle: "返回首页后，将无法回到当前实时录制，需重新输入链接再次进入",
            confirmText: "返回",
            cancelText: "暂不返回",
          }}/>}
          {meetingFinish && (
            <div className="text-mx-quaternary text-3 lh-6 flex flex-row items-center gap-1">
              <SyncSuccessIcon />
              <span>大屏会议已结束，智能总结生成中...</span>
            </div>
          )}
          <div className="flex-1 h-12 flex justify-end items-center px-6 gap-4">
            <TranslationSelector
              translationOption={translationOption}
              setTranslationOption={setTranslationOption}
              className='bg-#FFF rounded-2 py-1 px-2'
            />
            {RuningInLink && (
              <div>
                <div className="w-0.25 h-4 bg-#243F6C op-10"></div>
                <div
                  onClick={() => {
                    setShowExitDialog(true);
                  }}
                  className="b-1 b-solid b-mx-error flex items-center justify-center rounded-2.5 w-15 h-8 text-mx-error"
                >
                  退出
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      <Dialog
        isOpen={showExitDialog}
        onCancel={() => setShowExitDialog(false)}
        onConfirm={handleExit}
        title=""
        content="确定退出吗？大屏会议结束后，记录将自动保存至最近列表"
        confirmText="退出"
      />
      <Dialog
        isOpen={showJumpSummaryDialog}
        onCancel={() => {
          setShowJumpSummaryDialog(false);
          setModalCancel(true);
        }}
        onConfirm={handleJumpSummary}
        confirmType="primary"
        confirmText="查看"
        confirmTimeout={10 * 1000}
        title="大屏会议已结束"
        content="正在为你跳转智能总结详情"
      />

      <div className="flex flex-1 flex-row w-full p-6 pt-1 relative overflow-hidden ">
        <SrcContent streamName={streamId} />
        {showbar && RuningInLink && <CollaborationSidebar />}
      </div>
    </div>
  );
};

export default WebCollaboration; 